/* eslint-disable max-len */
import React from "react"
import { Space, Typography } from "antd"
import { WarningOutlined } from "@ant-design/icons"

export default function ConfidentialityDisclaimer() {

  const styles = {
    space: {
      padding: "4px",
      marginTop: "5rem",
      textAlign: "center",
      textJustify: "inter-word",
      position: "relative",
      zIndex: 1,
      bottom: 0
    },
    icon: {
      color: "#FFE58F",
      fontSize: "26px"
    },
    text: {
      fontSize: "12px",
      color: "#FFFFFF"
    }
  }

  return (
    <Space
      size="small"
      direction="vertical"
      style={styles.space}>
      <Typography.Paragraph>
        <Typography.Title>
          <WarningOutlined style={styles.icon} />
        </Typography.Title>
        <Typography.Text style={styles.text}>
          La información contenida en este sitio es confidencial y para uso exclusivo de FICOSEC. Cualquier impresión o copia tomada de esta plataforma será considerada como copia no autorizada.
        </Typography.Text>
      </Typography.Paragraph>
    </Space>
  )
}
